import ClickableIcon from '@/components/ClickableIcon'
import { Edit2 } from '@/components/Icons'
import DeleteIconTooltip from '@/pages/OrganizationUserAttributesPage/DeleteIconTooltip'

import messages from './messages'

export default ({ intl, onDelete, onEdit }: any) => [
  {
    property: 'displayName',
    header: { label: intl.formatMessage(messages.labelDisplayName) },
    cell: { props: { className: 'attribute-list__column attribute-list__column--display-name' } }
  },
  {
    property: 'type',
    header: { label: intl.formatMessage(messages.labelType) },
    cell: {
      formatters: [
        // @ts-expect-error
        (type: any, { rowData: attribute }) => {
          const wrap = (children: any) => <span className="sub-text">{children}</span>

          switch (type) {
            case 'binary': {
              return wrap(intl.formatMessage(messages.typeBinary))
            }

            case 'complex': {
              return wrap(intl.formatMessage(attribute.multiValued ? messages.typeList : messages.typeComplex))
            }

            case 'boolean': {
              return wrap(intl.formatMessage(messages.typeBoolean))
            }

            case 'datetime': {
              return wrap(intl.formatMessage(messages.typeDateTime))
            }

            case 'decimal': {
              return wrap(intl.formatMessage(messages.typeDecimal))
            }

            case 'integer': {
              return wrap(intl.formatMessage(messages.typeInteger))
            }

            // eslint-disable-next-line unicorn/no-useless-switch-case
            case 'string':
            default: {
              return wrap(intl.formatMessage(messages.typeString))
            }
          }
        }
      ],
      props: { className: 'attribute-list__column attribute-list__column--type' }
    }
  },
  {
    property: 'targetable',
    header: { label: intl.formatMessage(messages.labelTargetable), props: { className: 'text-center' } },
    cell: {
      formatters: [
        (targetable: any, { rowData }: any) => {
          return rowData.scimParentAttributeName ? null : (
            <span className="sub-text">{intl.formatMessage(targetable ? messages.yes : messages.no)}</span>
          )
        }
      ],
      props: { className: 'attribute-list__column attribute-list__column--targetable text-center' }
    }
  },
  {
    property: 'id',
    cell: {
      // TODO Remove this onClick and wrap it in a button
      formatters: [(attributeId: any) => <ClickableIcon callback={onEdit} parameter={attributeId} render={Edit2} />],
      props: { className: 'attribute-list__column attribute-list__column--edit text-center' }
    }
  },
  {
    property: 'id',
    cell: {
      formatters: [
        // @ts-expect-error
        (attributeId: any, { rowData: attribute }) => <DeleteIconTooltip attribute={attribute} onClick={onDelete} />
      ],
      props: { className: 'attribute-list__column attribute-list__column--delete text-center' }
    }
  }
]
